import { API_BASE } from "utils/api";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Divider,
  CardHeader,
  Typography,
} from "@mui/material";

import { useEffect, useState } from "react";
import { SelectChangeEvent } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import MoneyIcon from "@mui/icons-material/Money";
import PeopleIcon from "@mui/icons-material/PeopleOutlined";
import { red, green } from "@mui/material/colors";
import ProfitGreen from "icons/Profit";
import ProfitMargin from "icons/Margin";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { usePromiseTracker } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { callCompleted } from "redux/salesPromise";
export interface dailyDurationSales {
  durationSales: number;
  totalSales: number;
  change: number[];
}

interface BudgetParams {
  avgItemTr: string;
  text: string;
  isSales: number;
  dayShow: boolean;
  weekShow: boolean;
  monthShow: boolean;
  threeMonthsShow: boolean;
  sixMonthsShow: boolean;
  dataToAsk: string;
  GetTotalSales?: (newType: dailyDurationSales) => any;
  result?: {
    durationSales?: number;
    totalSales: number;
    change: number[];
  };
}

const Budget = ({
  avgItemTr,
  text,
  isSales,
  dayShow,
  weekShow,
  monthShow,
  threeMonthsShow,
  sixMonthsShow,
  GetTotalSales,
  dataToAsk,
  result: resultOverride,
}: BudgetParams) => {
  const dispatch = useDispatch();
  const [result, setResult] = useState<{
    durationSales: number;
    totalSales: number;
    change: number[];
  }>({
    durationSales: 0,
    totalSales: 0,
    change: [],
  });
  const [yearsChange, setYearsChange] = useState(0);
  const { promiseInProgress } = usePromiseTracker();

  useEffect(() => {
    if (resultOverride) {
      setResult({
        durationSales: resultOverride.durationSales ?? 0,
        totalSales: resultOverride.totalSales,
        change: resultOverride.change,
      });
      return;
    }
    trackPromise(
      axios
        .get(`${API_BASE}/purchase/periodic_sales`, {
          params: {
            allStores: true,
            avgItemTr: avgItemTr,
            daily: dayShow,
            weekly: weekShow,
            monthly: monthShow,
            threeMonths: threeMonthsShow,
            sixMonths: sixMonthsShow,
          },
        })
        .then((response) => setResult(response.data)),
    );
  }, [weekShow, monthShow, threeMonthsShow, sixMonthsShow, resultOverride]);

  if (avgItemTr == "1") {
    GetTotalSales?.(result);
  }

  const handleChange = (event: SelectChangeEvent<any>) => {
    setYearsChange(event.target.value as number);
  };

  const totalSalesNumber = result.totalSales.toLocaleString();

  switch (dataToAsk) {
    case "totalSales":
      dispatch(callCompleted({ totalSales: promiseInProgress }));
      break;
    case "totalTransactions":
      dispatch(callCompleted({ totalTransactions: promiseInProgress }));
      break;
    case "totalItems":
      dispatch(callCompleted({ totalItems: promiseInProgress }));
      break;
    case "averageItemsPerTransaction":
      dispatch(
        callCompleted({ averageItemsPerTransaction: promiseInProgress }),
      );
      break;
  }

  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 2.5,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
        transition: "box-shadow 0.2s ease, transform 0.2s ease",
        "&:hover": {
          boxShadow: "0 10px 28px rgba(16, 24, 40, 0.10)",
          transform: "translateY(-2px)",
        },
      }}
    >
      <CardHeader
        title={text}
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
      ></CardHeader>

      <Divider />
      <CardContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            pt: 2,
            pb: 1,
            height: 160,
            maxWidth: 200,
            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              columnGap: 1,
            }}
          >
            <Typography
              color="textPrimary"
              variant="h4"
              sx={{
                flex: 1,
                minWidth: 0,
                fontSize: 24,
                lineHeight: 1.15,
              }}
            >
              {totalSalesNumber}
            </Typography>

            {isSales === 1 ? (
              <Avatar
                sx={{
                  backgroundColor: red[600],
                  height: 40,
                  width: 40,
                  flexShrink: 0,
                }}
              >
                <MoneyIcon />
              </Avatar>
            ) : isSales === 2 ? (
              <Avatar
                sx={{
                  backgroundColor: green[600],
                  height: 40,
                  width: 40,
                  flexShrink: 0,
                }}
              >
                <PeopleIcon />
              </Avatar>
            ) : isSales === 3 ? (
              <Avatar
                sx={{
                  backgroundColor: green[600],
                  height: 40,
                  width: 40,
                  flexShrink: 0,
                }}
              >
                <ProfitGreen />
              </Avatar>
            ) : (
              <Avatar
                sx={{
                  backgroundColor: red[600],
                  height: 40,
                  width: 40,
                  flexShrink: 0,
                }}
              >
                <ProfitMargin />
              </Avatar>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              columnGap: 1,
            }}
          >
            <FormControl style={{ width: 120 }}>
              <InputLabel id="changed from last years"> Changed</InputLabel>
              <Select
                labelId="changed-from-last-years"
                id="change"
                value={yearsChange}
                label="Change"
                onChange={handleChange}
                size="small"
              >
                <MenuItem value={0} sx={{ color: "#86086D" }}>
                  {" "}
                  2025{" "}
                </MenuItem>
                <MenuItem value={1} sx={{ color: "#0D830F" }}>
                  {" "}
                  2024{" "}
                </MenuItem>
              </Select>
            </FormControl>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {result.change[yearsChange] < 0 ? (
                <ArrowDownwardIcon sx={{ color: red[900] }} />
              ) : (
                <ArrowUpwardIcon sx={{ color: green[900] }} />
              )}
              <Typography
                variant="body2"
                sx={{
                  mr: 1,
                }}
              >
                {result.change[yearsChange]}%
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Budget;
